import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Column from "./components/Column";
import Section from "./components/Section";
import ServiceLink from "./components/ServiceLink";

import strings from "../../locales/strings";

import styles from "./AllServices.scss";

const cx = classnames.bind(styles);
const isGuaranteePaymentNew = new Date("2025-03-07T00:00:00.000Z") > new Date();
const isCourierNew = new Date("2025-12-06T00:00:00.000Z") > new Date();
const isCargoMapNew = new Date("2026-02-18T00:00:00.000Z") > new Date();

// При добавлении лейбла isNew необходимо установить условие его автоматического снятия через год
// и добавить напоминалку в слаке за день до дня снятия
// Подробнее можно узнать в задаче https://kaiten.ati.st/space/108/card/120077

const AllServices = ({ isMobile }) => (
  <div className={cx("wrapper", { "is-mobile": isMobile })}>
    <Column>
      <Section label={strings.automationHeader}>
        <ServiceLink name="api" />
        <ServiceLink name="gps" />
        <ServiceLink name="docs" />
        <ServiceLink name="orders" />
        <ServiceLink name="boards" />
        <ServiceLink name="catalogs" />
        <ServiceLink name="tenders" />
        <ServiceLink name="auction" />
      </Section>
    </Column>
    <Column>
      <Section label={strings.statisticHeader}>
        <ServiceLink name="profitable-destinations" />
        <ServiceLink name="index" />
        <ServiceLink name="cargo-map" isNew={isCargoMapNew} />
        <ServiceLink name="middle-price" />
      </Section>
      <Section label={strings.securityHeader}>
        <ServiceLink name="unlimited-check" />
        <ServiceLink name="guarantee-payment" isNew={isGuaranteePaymentNew} />
        <ServiceLink name="check" />
        <ServiceLink name="traffic-light" />
        <ServiceLink name="insurance" />
      </Section>
    </Column>
    <Column>
      <Section label={strings.comunicationHeader}>
        <ServiceLink name="messenger" />
        <ServiceLink name="tickets" />
        <ServiceLink name="forums" />
      </Section>
      <Section label={strings.addInstrumentsHeader}>
        <ServiceLink name="courier" isNew={isCourierNew} />
        <ServiceLink name="time-slots" />
        <ServiceLink name="real-truck" />
        <ServiceLink name="distance-calculator" />
        <ServiceLink name="chains" />
      </Section>
    </Column>
    <Column>
      <Section label={strings.usefulHeader}>
        <ServiceLink name="automation" isNew />
        <ServiceLink name="academy" />
        <ServiceLink name="loans" />
        <ServiceLink name="news" />
        <ServiceLink name="partnership" />
        <ServiceLink name="truckmarket" />
        <ServiceLink name="rating" />
        <ServiceLink name="partners-offers" />
      </Section>
    </Column>
  </div>
);

AllServices.propTypes = {
  isMobile: PropTypes.bool,
};

export default AllServices;
